import { Hero } from '../components/Hero';
import { ContactInfoCard } from '../components/ContactInfoCard';

const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.5" stroke="currentColor">
    <path d="M3 7l9 6 9-6M5 5h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const HeartIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.5" stroke="currentColor">
    <path d="M12 21s-7-4.534-9.5-9A5.5 5.5 0 0 1 12 6a5.5 5.5 0 0 1 9.5 6c-2.5 4.466-9.5 9-9.5 9z" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PinIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.5" stroke="currentColor">
    <path d="M12 21s7-7.5 7-12a7 7 0 1 0-14 0c0 4.5 7 12 7 12z" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="12" cy="9" r="2.5" strokeLinecap="round" />
  </svg>
);

export const ContactPage = () => {
  return (
    <>
      <Hero
        title="Neem contact op"
        description="Heb je interesse of vragen? Kom naar het veld toe voor een praatje. Je kan ons ook bereiken via de mail of Instagram."
        imageSrc="/images/hero-contact.jpg"
        overlay={false}
        fullHeight
        eyebrow="Contact · Ten Boer & Bedum"
      />

      <section className="py-28 md:py-36 px-6 sm:px-10 md:px-16 bg-[#FBFAF6]">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16 md:mb-20">
            <div className="md:col-span-5">
              <span className="eyebrow text-[#0D0A00]/60">Bereikbaarheid</span>
            </div>
            <div className="md:col-span-7">
              <h2 className="text-[#0D0A00] text-[40px] md:text-[52px] font-medium tracking-[-0.03em] leading-[1.03]">
                Drie manieren om{' '}
                <span className="font-serif-display italic font-normal text-[#0D0A00]/70">ons te bereiken.</span>
              </h2>
            </div>
          </div>

          {/* Two equal location cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-stretch">
            <ContactInfoCard
              title="Ten Boer"
              description="Heb je vragen over Restart in Ten Boer? Stuur ons een mail of kom langs bij het veld — we maken graag tijd."
              email="sc.restarttenboer@gmail.com"
              icon={<PinIcon />}
            />
            <ContactInfoCard
              title="Bedum"
              description="Heb je vragen over Restart in Bedum? Stuur ons een mail of kom langs bij het veld."
              email="sc.restarttenboer@gmail.com"
              icon={<MailIcon />}
            />
          </div>

          {/* Meehelpen — wide CTA banner with a different layout */}
          <div className="mt-6 md:mt-8">
            <article className="group relative grid grid-cols-1 md:grid-cols-12 gap-8 items-center p-8 md:p-12 rounded-[24px] border border-[#0D0A00]/8 bg-[#0D0A00] text-white overflow-hidden">
              <div
                className="absolute -top-32 -right-32 w-[360px] h-[360px] rounded-full opacity-[0.10] blur-3xl pointer-events-none"
                style={{ background: '#F5B800' }}
              />
              <div className="md:col-span-1 flex md:justify-start">
                <div className="w-10 h-10 text-[#F5B800] [&_svg]:w-full [&_svg]:h-full">
                  <HeartIcon />
                </div>
              </div>
              <div className="md:col-span-7 relative">
                <h3 className="text-white text-[26px] md:text-[30px] font-medium tracking-[-0.025em] leading-tight mb-3">
                  Meehelpen
                </h3>
                <p className="text-white/65 text-[15.5px] leading-[1.65] max-w-[58ch]">
                  Wil je meehelpen als vrijwilliger of een bijdrage leveren? We horen graag van je — geen ervaring nodig, alleen tijd en aandacht.
                </p>
              </div>
              <div className="md:col-span-4 relative flex md:justify-end">
                <a
                  href="mailto:sc.restarttenboer@gmail.com"
                  className="btn-pill"
                  style={{ background: '#F5B800', color: '#0D0A00' }}
                >
                  sc.restarttenboer@gmail.com
                  <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                    <path d="M2 6H10M10 6L6 2M10 6L6 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </a>
              </div>
            </article>
          </div>
        </div>
      </section>
    </>
  );
};
